<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="flex flex-wrap align-center">
                <div class="count"><span>{{detail.count}}</span>项服务</div>
                <div class="tag" v-for="(tag,position) in detail.label" :key="position">{{tag}}</div>
            </div>
            <div class="page-back" @click="toBack">返回</div>
        </div>
        <div class="flex flex-direction margin-top">
            <div class="title">{{detail.title}}</div>
            <div class="content">{{detail.desc}}</div>
            <div class="flex flex-wrap">
                <div class="item-service flex flex-direction align-center justify-center"
                     v-for="(item,index) in detail.son" :key="index">
                    <div class="title">{{item.title}}</div>
                    <div class="content">{{item.content}}</div>
                    <el-button class="operate" @click="apply(item.id)" v-if="item.status === 0 || item.status === 2">申请服务</el-button>
                  <el-button class="operate white" v-if="item.status === 1">已申请</el-button>

                  <div class="apply-list" v-if="item.applyUserList.length>0">
                    <div class="page-title">申请记录</div>
                    <div class="ship-list">
                      <el-table
                        :data="item.applyUserList" header-row-class-name="table-header"
                        border
                        style="width: 100%; border-radius: 10px">
                        <el-table-column
                          label="序号"
                          type="index"
                          width="50">
                          <template slot-scope="scope">
                            <div class="flex justify-center">
                              {{ scope.$index + 1 }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="申请时间" prop="add_time" width="150px" >
                          <template slot-scope="scope">
                            <div class="flex justify-center"> {{ scope.row.add_time |time }}</div>
                          </template>
                        </el-table-column>
                        <el-table-column label="申请内容" prop="content">
                          <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.content }}</div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="status" label="申请状态" width="150px">
                          <template slot-scope="scope">
                            <div class="flex justify-center">
                              {{ scope.row.status === 1 ? '处理中' : '已处理' }}
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
            </div>



        </div>
        <apply-service-dialog :sid="cur_id" :applyDialogVisible="applyDialogVisible" @watchState="watchState"></apply-service-dialog>
    </div>
</template>

<script>
    import {getServerDetail} from '@/api/member'
    import ApplyServiceDialog from "@/components/ApplyServiceDialog.vue";
    import {zhDate} from "@/utils/utils";

    export default {
        components: {ApplyServiceDialog},
        name: "serviceDetail",
        data() {
            return {
                id: '',
                detail: '',

                cur_id: 0,
                applyDialogVisible: false
            }
        },
        created() {
            this.$emit('setIndex', [4], '服务中心-服务详情')
            this.id = this.$route.query.id
            this.init()
        },
        computed: {},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getServerDetail(this.id)
                if (_data.status === 200) {
                    _data.data.label = _data.data.label ? _data.data.label.split(',') : []
                    _data.data.count = _data.data.son.length
                    this.detail = _data.data
                }
            },
            apply(id) {
                this.cur_id = id
                this.applyDialogVisible = true
            },
            watchState(state) {
                if (state) this.init()
                this.applyDialogVisible = false;
            },
            toBack() {
                this.$router.go(-1)
            }
        },
      filters:{
        time(val){
          return zhDate(new Date(val*1000))
        }
      }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        .title {
            font-size: 22px;
            font-weight: bold;
            color: #0a2240;
          line-height: 28px;
        }
        .content {
            width: 100%;
            font-size: 16px;
            line-height: 26px;
            color: #4b648a;
            margin-top: 22px;
        }
        .count {
            min-width: 89px;
            height: 28px;
            line-height: 28px;
            background-color: #0a2240;
            border-radius: 10px;
            border: solid 1px #0a2240;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            padding: 0 12px;
            margin-top: 15px;
            margin-right: 20px;
            span {
                color: #ff9600;
                font-weight: bold;
            }
        }
        .tag {
            min-width: 82px;
            height: 28px;
            line-height: 28px;
            background-color: #f3f7fb;
            border-radius: 14px;
            border: solid 1px #0a2240;
            font-size: 14px;
            color: #0a2240;
            text-align: center;
            margin-top: 15px;
            margin-right: 20px;
            padding: 0 12px;
        }
      .apply-list{
        width: 100%;
        .page-title{
          line-height: 40px;
          font-size: 18px;
        }
      }
        .item-service {
            width: 100%;
            background-color: #f3f7fb;
            border-radius: 10px;
            padding: 30px;
            margin-top: 20px;
            .title {
                font-size: 22px;
                font-weight: bold;
                color: #0a2240;
            }
            .content {
                font-size: 14px;
                line-height: 24px;
                color: #0a2240;
                margin-top: 22px;
            }
            .operate {
                width: 150px;
                height: 36px;
                line-height: 36px;
                border-radius: 20px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;
                margin-top: 20px;
                padding: 0;
                &.white {
                    background: #ffffff none;
                    color: #ff9600;
                }
                &:disabled {
                    background: #b4c7e5 none;
                }
            }
        }
    }

</style>